const ROUTE_STANDARDS = [
  { pattern: "/messages-embed", module: "embed", page: "messages_embed", track: true },
  { pattern: "/send-message-embed", module: "embed", page: "send_embed", track: true },
  { pattern: "/messaging-iframe", module: "embed", page: "messaging_iframe", track: false },
  { pattern: "/messaging-embed", module: "embed", page: "messaging_embed", track: true },
  { pattern: "/embeded-alert", module: "embed", page: "alert_details_embed", track: true },
  { pattern: "/setup-password", module: "account", page: "setup_password", track: false },
  { pattern: "/help", module: "help", page: "help_center", track: true },
  { pattern: "/templates", module: "templates", page: "template_management", track: true },
  { pattern: "/reports", module: "reports", page: "reports", track: true },
  { pattern: "/group-members/:id", module: "groups", page: "group_members", track: true },
  { pattern: "/groups", module: "groups", page: "groups", track: true },
  { pattern: "/people", module: "people", page: "people", track: true },
  { pattern: "/messages", module: "messages", page: "messages", track: true },
  { pattern: "/send", module: "alerts", page: "send_alert", track: true },
  { pattern: "/alert", module: "alerts", page: "alert_details", track: true },
  { pattern: "/", module: "dashboard", page: "dashboard", track: true },
];

const NAME_PATTERN = /^[a-z0-9_]+$/;

export const PENDO_TRACKING_STANDARDS = {
  eventPrefix: "hgs_pwa",
  eventNamePattern: "hgs_pwa.<domain>.<feature>.<action>",
  pageTagPattern: "<module>:<page>",
  guideTagPattern: "guide:<name>",
};

function normalizeToken(value) {
  return (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function isValidTrackingToken(value) {
  return NAME_PATTERN.test(normalizeToken(value));
}

export function buildEventName(domain, feature, action) {
  const normalizedDomain = normalizeToken(domain);
  const normalizedFeature = normalizeToken(feature);
  const normalizedAction = normalizeToken(action);
  return [PENDO_TRACKING_STANDARDS.eventPrefix, normalizedDomain, normalizedFeature, normalizedAction].join(".");
}

function isRouteMatch(pattern, pathname) {
  if (pattern === pathname) return true;
  const patternParts = pattern.split("/").filter(Boolean);
  const pathParts = pathname.split("/").filter(Boolean);
  if (patternParts.length !== pathParts.length) return false;

  for (let i = 0; i < patternParts.length; i += 1) {
    if (patternParts[i].startsWith(":")) continue;
    if (patternParts[i] !== pathParts[i]) return false;
  }
  return true;
}

export function resolveRouteTag(pathname = "/") {
  const match = ROUTE_STANDARDS.find((route) => isRouteMatch(route.pattern, pathname));
  if (match) return match;

  const pathTokens = pathname.split("/").filter(Boolean).map(normalizeToken);
  const moduleName = pathTokens[0] || "dashboard";
  const pageName = pathTokens.join("_") || "dashboard";
  return { pattern: pathname, module: moduleName, page: pageName, track: true };
}

export function buildPageTag(pathname = "/") {
  const route = resolveRouteTag(pathname);
  return `${route.module}:${route.page}`;
}

export function trackPageView(pathname, metadata = {}, options = {}) {
  const pendo = options.pendo || window.pendo;
  if (!pendo || typeof pendo.pageLoad !== "function") return false;

  const route = resolveRouteTag(pathname);
  if (route.track === false) return false;

  const pageTag = buildPageTag(pathname);
  pendo.pageLoad({
    page: {
      key: pageTag,
      module: route.module,
      name: route.page,
      path: pathname,
    },
    tags: {
      page_tag: pageTag,
      tracking_standard: PENDO_TRACKING_STANDARDS.pageTagPattern,
      ...metadata,
    },
  });
  return true;
}

export function trackFeatureEvent(domain, feature, action, metadata = {}, options = {}) {
  const pendo = options.pendo || window.pendo;
  if (!pendo || typeof pendo.track !== "function") return false;

  const eventName = buildEventName(domain, feature, action);
  pendo.track(eventName, {
    tracking_standard: PENDO_TRACKING_STANDARDS.eventNamePattern,
    ...metadata,
  });
  return true;
}

export function trackGuideEvent(guideName, action = "viewed", metadata = {}, options = {}) {
  const normalizedGuide = normalizeToken(guideName);
  const guideEventName = buildEventName("guide", normalizedGuide || "unknown", action);
  return trackFeatureEvent("guide", normalizedGuide || "unknown", action, {
    guide_tag: `guide:${normalizedGuide || "unknown"}`,
    event_name: guideEventName,
    ...metadata,
  }, options);
}
